import { render } from "./CompanyModal.vue?vue&type=template&id=6be4e3a6&scoped=true&ts=true"
import script from "./CompanyModal.vue?vue&type=script&lang=ts"
export * from "./CompanyModal.vue?vue&type=script&lang=ts"

import "./CompanyModal.vue?vue&type=style&index=0&id=6be4e3a6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be4e3a6"]])

export default __exports__